export default __webpack_public_path__ + "static/media/bg-image.e49c7a90.png";